module.exports = __webpack_public_path__ + "img/avatar-default.50d7d51e.png";